const growlerMessages = {
  'error': 'Wrong username or password',
};

export default growlerMessages;



/** WEBPACK FOOTER **
 ** ./src/locales/en_US/growler.en_us.js
 **/